import { defineComponent as _defineComponent } from 'vue'
import { isEmployeeOnly } from "@/auth/auth.roles";
import { auth } from "@/stores/auth.store";
import { useUserStore } from "@/stores/user.store";
import { useFragment, UserMainFieldsFragmentDoc, UserOverviewFragmentDoc } from "owfsa-graphql";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const router = useRouter();
const isAuthenticated = computed(() => auth?.account !== null);
const networkError = ref();

watch(
  [isAuthenticated, () => router.currentRoute.value.name, () => userStore.self],
  ([isAuth, routeName]) => {
    if (
      isAuth &&
      routeName === "home" &&
      userStore.userExists &&
      !userStore.isBlocked &&
      isEmployeeOnly()
    ) {
      router.replace({ name: "work-schedule" });
    }
  },
  { immediate: true },
);

watch(isAuthenticated, async (isAuth) => {
  if (isAuth) {
    const result = await userStore.getSelfQuery.executeQuery({
      requestPolicy: "network-only",
    });

    networkError.value = result.error?.value;
    // unwrap the fragment twice to get proper typing
    const userFrag = useFragment(UserMainFieldsFragmentDoc, result.data.value?.self);
    userStore.self = userFrag ? useFragment(UserOverviewFragmentDoc, userFrag) : null;
  } else {
    userStore.self = null;
  }
}, { immediate: true });

const __returned__ = { userStore, router, isAuthenticated, networkError, get auth() { return auth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})